// extracted by mini-css-extract-plugin
export default {"searchInput":"CloudFilesCollectionControlBar_searchInput__ov7kK"};